import { useQuery } from "@tanstack/react-query";
import moment from "moment";
import { apiClient } from "../../../zodios/client";
import { useAppSelector } from "../../../redux/hooks";

// Active advertisements per bidding program over the last two days, keyed by program id.
export const useBiddingProgramActiveAdCounts = () => {
  const marketplace = useAppSelector((state) => state.marketPlace.marketPlace);
  const startDate = moment().subtract(2, "days").format("YYYY-MM-DD");
  const endDate = moment().format("YYYY-MM-DD");

  return useQuery({
    queryKey: ["biddingProgramActiveAdCounts", marketplace, startDate, endDate],
    queryFn: async () =>
      await apiClient.getV4AdvReportByProgram({
        queries: { marketplace, start_date: startDate, end_date: endDate },
      }),
    select: (data) => {
      const counts: Record<number, number> = {};
      for (const row of data.data) {
        if (row.program_id != null) counts[row.program_id] = row.active_ad_count ?? 0;
      }
      return counts;
    },
  });
};
